/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/chat-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const ChatExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoice'],
            default: 'PureMultipleChoice'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message for the submission. For the correct answer this is the success message.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check a single box for the correct answer.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems'],
        title: 'SingleCorrectAnswer'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleAnswers'],
            default: 'PureMultipleAnswers'
          },
          successMessage: {
            type: 'string',
            default: 'Well done!',
            description: 'Feedback message when the submission is correct.'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message when the submission is incorrect.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check the box if the answer is correct.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            default: 'Well done!',
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems', 'successMessage'],
        title: 'MultipleCorrectAnswers'
      }]
    },
    prompts: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          prompt: {
            type: 'string',
            default: 'A prompt',
            description: 'Possible prompt choice.'
          },
          response: {
            type: 'string',
            default: 'A response',
            description: 'The preset response for this prompt.'
          }
        },
        required: ['prompt', 'response']
      }
    },
    enableExternalChatGPT: {
      type: 'boolean',
      default: false,
      description: 'Enable/disable use of ChatGPT.'
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'prompts', 'question', 'title', 'xp'],
  definitions: {}
};
export const isValidChatExerciseV0 = createValidator(ChatExerciseV0Schema);
export const ChatExerciseV0Definition = {
  schema: ChatExerciseV0Schema,
  validate: isValidChatExerciseV0
};